import { render, staticRenderFns } from "./RequiredNutrient.vue?vue&type=template&id=41a76222&scoped=true&"
import script from "./RequiredNutrient.vue?vue&type=script&lang=js&"
export * from "./RequiredNutrient.vue?vue&type=script&lang=js&"
import style0 from "./RequiredNutrient.vue?vue&type=style&index=0&id=41a76222&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a76222",
  null
  
)

export default component.exports